import { Pipe, PipeTransform } from '@angular/core';

import { ÉtatSéquence } from '../models/état-séquence.enum';

@Pipe({
  name: 'convertEtatSequenceToString',
})
export class ConvertEtatSequenceToStringPipe implements PipeTransform {
  transform(value?: ÉtatSéquence): string {
    if (!value) {
      return '';
    }
    switch (value) {
      case ÉtatSéquence.A_FAIRE:
        return 'À Faire';
      case ÉtatSéquence.EN_COURS:
        return 'En cours';
      case ÉtatSéquence.TERMINEE:
        return 'Terminée';
      case ÉtatSéquence.DESACTIVEE:
        return 'Désactivée';
    }
  }
}
